export enum SocialMediaPlatform {
  Facebook = 'facebook',
  Google = 'google',
}
